/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ change: NonNullable<unknown> }} Dashboard_Stats_Fromlastmonth2Inputs */

const he_dashboard_stats_fromlastmonth2 = /** @type {(inputs: Dashboard_Stats_Fromlastmonth2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.change} מהחודש שעבר`)
};

const en_dashboard_stats_fromlastmonth2 = /** @type {(inputs: Dashboard_Stats_Fromlastmonth2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.change} from last month`)
};

/**
* | output |
* | --- |
* | "{change} from last month" |
*
* @param {Dashboard_Stats_Fromlastmonth2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const dashboard_stats_fromlastmonth2 = /** @type {((inputs: Dashboard_Stats_Fromlastmonth2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Stats_Fromlastmonth2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_stats_fromlastmonth2(inputs)
	return en_dashboard_stats_fromlastmonth2(inputs)
});
export { dashboard_stats_fromlastmonth2 as "dashboard_stats_fromLastMonth" }